(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["lx-price-badge"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lx-price-badge')) {
customElements.define('lx-price-badge', class extends HTMLElement {
connectedCallback() {
this.scope = this.closest('.shopify-section, dialog');
this.onVariantUpdate = (event) => {
const html = event.detail && event.detail.data && event.detail.data.html;
if (!html) return;
const fresh = html.querySelector('lx-price-badge[data-block-id="' + this.dataset.blockId + '"]');
if (fresh) this.innerHTML = fresh.innerHTML;
};
if (this.scope) this.scope.addEventListener('variant:update', this.onVariantUpdate);
}
disconnectedCallback() {
if (this.scope) this.scope.removeEventListener('variant:update', this.onVariantUpdate);
}
});
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["lx-proof-line"] && !Shopify.designMode) return;
  try {
    if (!window.__lxScrollBound) {
window.__lxScrollBound = true;
document.addEventListener('click', function (event) {
var link = event.target.closest ? event.target.closest('[data-lx-scroll]') : null;
if (!link) return;
var id = (link.getAttribute('href') || '').slice(1);
var target = id ? document.getElementById(id) : null;
if (!target) return;
event.preventDefault();
target.scrollIntoView({ behavior: 'smooth', block: 'start' });
setTimeout(function () {
var top = target.getBoundingClientRect().top;
if (top > 200 || top < -50) target.scrollIntoView({ behavior: 'instant', block: 'start' });
}, 1200);
});
}
  } catch(e) { console.error(e); }
})();

})();
